import { ButtonProps, Button } from "react-bootstrap";
import { ReactComponent as Next } from "assets/svg/outline-chevron-right.svg";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";
// import { usePhonePortraitContext } from "contexts/phone-portrait-context";

const NextButton = ({ className, ...props }: ButtonProps) => {
  // const { isPhonePortrait } = usePhonePortraitContext();
  return (
    <Button
      variant={"link"}
      size={"lg"}
      aria-label={"go next"}
      className={getClasses(styles["pagination-button-next"], className)}
      {...props}
    >
      <Next />
    </Button>
  );
};
export default NextButton;
